export enum TypesOfNotification {
  GROUP_CHATS_MESSAGE,
  P2P_CHATS_MESSAGE,
  MENTION_AND_QUOTE,
  GROUP_CHATS_CALL,
  P2P_CALL,
  PIN_MESSAGE,
  ROOM_CREATING,
}

export const ScheduleReminderOffset = {
  FIVE_MINUTES: '5m',
  ONE_HOUR: '1h',
} as const

export type ScheduleReminderOffsetValue =
  typeof ScheduleReminderOffset[keyof typeof ScheduleReminderOffset]
